// removed by extract-text-webpack-plugin
module.exports = {"Skill":"SkillElement__Skill__pwcU8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Builder/SkillList/SkillElement/SkillElement.css
// module id = 147
// module chunks = 0